<div class="col-xs-12">
  <div class="panel" [id]="panelId">
    <div>
      <div class="heading-big">{{ heading }}</div>
      <a [href]="link" target="_blank">{{ linkText }}</a>
    </div>
  </div>
</div>
